import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import { SingleDatePicker } from 'react-dates';

const propTypes = {
  // example props for the demo
  autoFocus: PropTypes.bool,
  autoFocusEndDate: PropTypes.bool,
  stateDateWrapper: PropTypes.func,
  //initialDate: PropTypes.func.isRequired,
};

class SingleDatePickerWrapper extends React.Component {
  constructor(props) {
    super(props);
    const { initialDate } = props;
    let focused = false;

    this.state = {
      focused,
      date: typeof initialDate !== 'undefined' ? initialDate : null,
    };
    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { initialDate } = nextProps;
    this.setState({
      ...this.state,
      date: initialDate,
    });
  }

  onDatesChange(date) {
    this.setState({ date });
    this.props.onDateChange(date);
    this.onFocusChange();
  }

  onFocusChange(focused) {
    this.setState(focused);
  }

  render() {
    const { focused, date } = this.state;
    const { t, id, error, placeholder, disabled = false } = this.props;
    const dateCheck = !!date ? false : error;
    const props = omit(this.props, [
      'initialDate',
      'classes',
      'error',
      't',
      'i18n',
      'tReady',
      'dispatch',
      'initialization',
    ]);
    
    return (
      <div className={dateCheck ? "onCheck" : ""}>
        <SingleDatePicker
          {...props}
          readOnly={true}
          onDateChange={this.onDatesChange}
          onFocusChange={this.onFocusChange}
          focused={focused}
          date={date}
          placeholder={!!placeholder ? placeholder : t('날짜 선택')}
          id={id}
          disabled={disabled}
        />
      </div>
    );
  }
}

SingleDatePickerWrapper.propTypes = propTypes;
// SingleDatePickerWrapper.defaultProps = defaultProps;

export default withTranslation()(SingleDatePickerWrapper);
